import type { FC } from 'react';

import { CallDetailsParticipant } from 'features/call/call-details/components';
import type { CallDetailsParticipantInfo } from 'features/call/call-details/interfaces';
import { Separator } from 'features/call/call-details/styles';
import { CustomGreeting } from 'features/custom-greeting/components';

export interface CallDetailsCalleeDisconnectedProps {
  callee: CallDetailsParticipantInfo;
  caller: CallDetailsParticipantInfo;
}

export const CallDetailsCalleeDisconnected: FC<
  CallDetailsCalleeDisconnectedProps
> = ({ callee, caller }) => {
  return (
    <>
      <CustomGreeting />
      <CallDetailsParticipant {...caller} />
      <Separator />
      <CallDetailsParticipant {...callee} />
    </>
  );
};
